import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { VelocityComponent } from 'velocity-react';

class Container extends React.Component {
    render() {
        const { style, decorators, terminal, onClick, node } = this.props;

        return (
            <div onClick={onClick}
                ref={ref => this.clickableRef = ref}
                style={style.container}>
                {!terminal ? this.renderToggle() : null}

                <decorators.Header node={node}
                    style={style.header}
                    show={this.props.show}
                    index={this.props.index}
                />
            </div>
        );
    }

    renderToggle() {
        const { animations } = this.props;

        if (!animations) {
            return this.renderToggleDecorator();
        }

        return (
            <VelocityComponent animation={animations.toggle.animation}
                duration={animations.toggle.duration}
                ref={ref => this.velocityRef = ref}>
                {this.renderToggleDecorator()}
            </VelocityComponent>
        );
    }

    renderToggleDecorator() {
        const { style, decorators } = this.props;

        return <decorators.Toggle style={style.toggle} />;
    }
}
Container.propTypes = {
    style: PropTypes.object.isRequired,
    decorators: PropTypes.object.isRequired,
    terminal: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    animations: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
    ]).isRequired,
    node: PropTypes.object.isRequired
};

export default Radium(Container)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Arbejdsmiljo/treebeard/components/container.js